// src/components/layout/mobile_Menu.jsx

// 모바일 전용 메뉴: 상위 메뉴 + 하위 항목까지 함께 렌더링
import { useState, useEffect } from "react";
import { useParams, useLocation, Link } from "react-router-dom";
import api from "../../../api/axios";
import { mobileProjectMenus } from "../mobile/ProjectMenus";

function MobileMenu({ isMenuOpen, onClose }) {
  const { id: projectId } = useParams();
  const location = useLocation();

  const [modules, setModules] = useState([]);
  const [openMenu, setOpenMenu] = useState(null);

  // 프로젝트 정보 불러오기 (modules_ordered: 어떤 모듈이 켜져 있는지)
  useEffect(() => {
    async function fetchProject() {
      try {
        const res = await api.get(`/project/info/${projectId}/`);
        setModules(res.data.modules_ordered || []);
      } catch (err) {
        console.error("프로젝트 정보 불러오기 실패:", err);
      }
    }
    if (projectId) fetchProject();
  }, [projectId]);

  // 현재 URL 기준으로 활성 메뉴 key 계산
  // /project/:id/ 다음에 오는 첫 번째 세그먼트를 정확히 추출
  const getModuleFromPath = () => {
    const pathSegments = location.pathname.split('/');
    const projectIndex = pathSegments.indexOf('project');
    if (projectIndex >= 0 && pathSegments.length > projectIndex + 2) {
      return pathSegments[projectIndex + 2]; // /project/:id/[모듈명]/...
    }
    return null;
  };

  const moduleSegment = getModuleFromPath();
  const activeKey = modules.find((key) => key === moduleSegment) || null;

  // 햄버거가 열릴 때: 활성 메뉴를 자동으로 펼치기
  useEffect(() => {
    if (isMenuOpen) {
      setOpenMenu(activeKey);
    } else {
      // 메뉴 닫히면 접어두기
      setOpenMenu(null);
    }
  }, [isMenuOpen, activeKey]);

  const toggleMenu = (key) => {
    setOpenMenu((prev) => (prev === key ? null : key));
  };

  // item.to 를 실제 Link용 to로 변환
  const buildTo = (menu, item) => {
    const base = menu.base(projectId);
    if (typeof item.to === "string") {
      if (!item.to) return base; // "" 인 경우 base로 이동
      return `${base}/${item.to}`;
    }
    // { pathname, search } 형태
    return {
      pathname: `${base}/${item.to.pathname}`,
      search: item.to.search,
    };
  };

  return (
    <div className="no-print">
      <div className="flex flex-col text-sm text-white">
        {modules
          .map((key) => {
            // 키 변환 (웹사이트 메뉴와 호환)
            let menuKey = key;
            if (key === "document") menuKey = "docs";
            else if (key === "material") menuKey = "materials"; // material → materials 변환
            else if (key === "construction") menuKey = "const"; // construction → const 변환

            const menu = mobileProjectMenus[menuKey];
            if (!menu) {
              console.warn(`[MobileMenu] 메뉴를 찾을 수 없습니다: key=${key}, menuKey=${menuKey}`);
              return null; // 정의 안 된 모듈은 스킵
            }

            const isOpen = openMenu === key;

            return (
              <div key={key} className="border-b border-white/15 last:border-b-0">
                {/* 상위 메뉴 버튼 */}
                <button
                  type="button"
                  onClick={() => toggleMenu(key)}
                  className={`w-full px-4 py-3 text-left font-semibold flex items-center justify-between ${isOpen ? "bg-white/10" : "hover:bg-white/5"
                    }`}
                >
                  <span>{menu.title}</span>
                  <span className="text-xs opacity-70">{isOpen ? "▲" : "▼"}</span>
                </button>

                {/* 하위 메뉴: 토글된 메뉴만 펼침 */}
                {isOpen && (
                  <div className="bg-[#252538] px-4 py-2 space-y-3">
                    {menu.sections.map((section, idx) => (
                      <div key={idx}>
                        <p className="text-[11px] text-gray-300 mb-1">
                          {section.title}
                        </p>
                        <div className="flex flex-col ml-2 border-l border-gray-600 pl-3">
                          {section.items.map((item, i) => (
                            <Link
                              key={i}
                              to={buildTo(menu, item)}
                              onClick={onClose}
                              className="py-1 text-gray-200 hover:text-white text-[12px]"
                            >
                              {item.label}
                            </Link>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
      </div>
    </div>
  );
}

export default MobileMenu;
